export const getCustomerAttributesCounts = state => state.customerAttributesCounts.get("data")
